// @flow
import moment from 'moment';

import { getDateFormat } from './getDateFormat';

/**
 * We know these are Date columns so to avoid extra parsing we are adding
 * them in here. We also support using Date<name> or <name>Date convention,
 * so any column using the Date prefix/suffix will be treated as Date.
 */
const DATE_COLUMNS_BINDINGS = [
  'Last',
  'Date',
  'InvoiceDate',
  'ExpDate',
  'DateSaved',
  'DateShip',
  'Rcpt',
  'EtaDate',
  'PoDate'
];

const DATE_FORMATS_BY_LENGTH = {
  6: 'server',
  10: 'clientDateFormat',
  17: 'serverWithTime',
};

const containsDatePrefixOrSuffix = str =>
  str.endsWith('Date') || str.startsWith('Date');

const parseData = (data: any) => {
  if (!Array.isArray(data)) {
    return [];
  }

  return data.map(i => {
    let extendedObj = {};

    DATE_COLUMNS_BINDINGS.forEach(binding => {
      const l = i[binding] && i[binding].length;
      if (
        (Object.prototype.hasOwnProperty.call(i, binding) ||
          containsDatePrefixOrSuffix(binding)) &&
        typeof i[binding] === 'string' &&
        DATE_FORMATS_BY_LENGTH[l]
      ) {
        const d = moment(
          i[binding],
          getDateFormat(DATE_FORMATS_BY_LENGTH[l]),
        ).toDate();

        if (d === 'Invalid Date') return;

        extendedObj[binding] = d;
      }
    });

    return {
      ...i,
      ...extendedObj,
    };
  });
};

const parseField = (field: string, value: any) => {
  if (
    !DATE_COLUMNS_BINDINGS.includes(field) &&
    !containsDatePrefixOrSuffix(field)
  )
    return value;

  if (!value || !DATE_FORMATS_BY_LENGTH[value.length]) return value;

  return moment(
    value,
    getDateFormat(DATE_FORMATS_BY_LENGTH[value.length]),
  ).toDate();
};

export { parseField, parseData };
